import { useEffect, useLayoutEffect } from "react";
import { ArrowRight } from "react-bootstrap-icons";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet, useLoaderData } from "react-router-dom";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import SideMenu from "../components/SideMenu/SideMenu";
import { setManualTypeReducer } from "../store/slice/manualTypeSlice";
import { setPlatformTypeReducer } from "../store/slice/platformTypeSlice";
import "./MainPage.scss";

const MainPage = () => {
  const storedManualType = useSelector(
    (state) => state.manualTypeChecker.manualType,
  );

  const { manualType, platformType } = useLoaderData();
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(setManualTypeReducer({ manualType }));

    if (manualType === "g") {
      dispatch(
        setPlatformTypeReducer({
          platformType: platformType === "kcp" ? "kcp" : "legacy",
        }),
      );
    }
  }, [dispatch, manualType, platformType]);

  useEffect(() => {
    document.title =
      manualType === "g"
        ? "클라우드 매뉴얼 (공공) | kt cloud"
        : "클라우드 매뉴얼 | kt cloud";
  }, [manualType]);

  if (storedManualType || manualType)
    return (
      <>
        <Header />
        <SideMenu />
        <div className="main">
          <Outlet />
          <Footer />
        </div>
      </>
    );
  else
    return (
      <>
        <div className="main-platform-switch-container">
          <Link className="platform-switch-menu" to="/g">
            G Cloud 매뉴얼
            <ArrowRight className="platform-switch-menu-icon" />
          </Link>
          <Link className="platform-switch-menu" to="/kt">
            KT Cloud 매뉴얼
            <ArrowRight className="platform-switch-menu-icon" />
          </Link>
        </div>
      </>
    );
};

export default MainPage;
